// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__2B7BF","alert__text":"alert_alert__text__29DBm","alert__icon":"alert_alert__icon__12sl0"};